// extracted by mini-css-extract-plugin
export default {"root":"EmailCard_root__+2JDw","header":"EmailCard_header__c3+sI","email":"EmailCard_email__wooRd","button":"EmailCard_button__MR83U"};